export const setupRoot = (rootElementId: string): HTMLElement =>
  document.getElementById(rootElementId) || document.body;
